import * as React from "react";
import { ListItem, Typography, Divider, Avatar } from "@material-ui/core";
import { Case, User, Category } from "../../api/classes";
import * as moment from "moment";
import { DEFAULT_AVATAR } from "src/auth/auth";

interface Props {
  case: Case;
  users: User[];
  categories: Category[];
  onClick?: () => void;
}
interface State {}
export default class CaseListItem extends React.Component<Props, State> {
  render() {
    return (
      <ListItem
        button
        key={this.props.case.id}
        onClick={this.props.onClick}
        style={{
          paddingTop: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: 24,
            marginLeft: 8,
            marginRight: 8
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <Typography variant="body1" style={{ flex: 1, fontSize: 16 }}>
              {this.props.case.title}
            </Typography>
            {this.renderStatus(this.props.case.status)}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 12,
              marginTop: 12
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1
              }}
            >
              <Typography variant="caption">#{this.props.case.id}</Typography>
              <Typography style={{ marginLeft: 8 }} variant="caption">
                {"opened " + moment(this.props.case.created_at).format("LL")}
              </Typography>
              {this.renderUser(this.props.case.user_id)}
            </div>
            {this.renderCategory(this.props.case.category_id)}
          </div>
          <Divider />
        </div>
      </ListItem>
    );
  }
  renderCategory(category_id) {
    let text = category_id;
    if (this.props.categories) {
      const cat = this.props.categories.find(i => i.id === category_id);
      if (cat) {
        text = cat.title;
      }
    }
    return (
      <Typography style={{ marginLeft: 8 }} variant="body2">
        {text}
      </Typography>
    );
  }
  renderUser(user_id) {
    const user =
      this.props.users && this.props.users.find(e => e.id === user_id);
    if (user) {
      return (
        <div style={{ display: "flex", flexDirection: "row", marginLeft: 12 }}>
          <Avatar
            style={{ width: 20, height: 20 }}
            src={user.account_picture || DEFAULT_AVATAR}
          />
          <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body2">
            {user.name}
          </Typography>
        </div>
      );
    } else {
      return null;
    }
  }
  renderStatus(status) {
    let color = "#ffffff00",
      text = "status";
    if (status === "pending") {
      color = "#ff9800";
      text = "Pending";
    } else if (status === "in_progress") {
      color = "#ff5722";
      text = "In Progress";
    } else if (status === "no_analysis") {
      color = "darkslategray";
      text = "No Analysis";
    } else if (status === "verified") {
      color = "green";
      text = "Verified";
    }
    return (
      <Typography
        style={{
          marginLeft: 16,
          backgroundColor: color,
          color: "white",
          padding: 2,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 6,
          fontSize: 14
        }}
        variant="caption"
      >
        {text}
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cases/caseListItem.tsx